import 'foundation-sites';
import "magnific-popup";
import 'slick-carousel';
import Dropzone from 'dropzone';
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';
import 'jquery-hoverintent';
import UserLocation from "./components/location/UserLocation";



jQueryBridget( 'masonry', Masonry, $ );

$(document).foundation();

global.$ = global.jQuery = require('jquery');

// HEADER -------------------------------------------------------------------

// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header').outerHeight();

$(window).scroll(function (event) {
    didScroll = true;
});

window.setInterval(function () {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 60);

function hasScrolled() {


    var st = $(window).scrollTop();

    //console.log('hasScrolled');
    //console.log('navbarHeight:'+navbarHeight)
    //console.log('st:'+st)



    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
        return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $('header').removeClass('nav-down').addClass('nav-up');

    } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
            $('header').removeClass('nav-up').addClass('nav-down');
        }
    }
    lastScrollTop = st;
}

// Megamenu
$(document).ready(function () {
    "use strict";
    // if li has children add class 'header-nav-dropdown'
    $('.header-nav > ul > li:has( > ul)').addClass('header-nav-dropdown');
    // when 'header-nav-dropdown' is hovered show dropdown and mask
    $(".header-nav-dropdown").hoverIntent({
        over: function () {
            $("> ul", $(this)).slideDown(300);
        },
        out: function () {
            $("> ul", $(this)).fadeOut(300);
        },
        timeout: 500
    });
});

// // Navigation for Small Screens
// $('.nav-mobile-toggle').on('click', function (e) {
//     var bodyHeight = $('body').height();
//     var windowHeight = $(window).height();
//     if (bodyHeight > windowHeight) {
//         $('body').toggleClass('no-scroll');
//     }
//     $(this).toggleClass('nav-close');
//     $('.nav-mobile').fadeToggle();
//     // $('#mask').fadeToggle();
//     e.preventDefault();
// });

// Navigation for Small Screens
$('.nav-mobile-toggle').on('click', function (e) {
    $('.nav-mobile').toggleClass('open');
    $('.nav-mobile-mask').fadeToggle(300);
    e.preventDefault();
});
$('.nav-mobile-mask, .nav-mobile-close').on('click', function (e) {
    $('.nav-mobile').removeClass('open');
    $('.nav-mobile-mask').fadeToggle(300);
    e.preventDefault();
});

// Show/Hide Search Bar
$('.header-search-toggle').on('click', function (e) {
    $('.header-search-toggle').toggleClass("open");
    $('.search').slideToggle(200);
    if (!$('.search').is(':hidden')) {
        $('#search').focus();
    }
    e.preventDefault();
});

// Show/Hide Enquiry List
$('.header-enquiry-list-toggle').on('click', function (e) {
    $('.enquiry-list').toggleClass('open');
    $('.enquiry-list-mask').fadeToggle(300);
    e.preventDefault();
});
$('.enquiry-list-mask, .enquiry-list-close').on('click', function (e) {
    $('.enquiry-list').removeClass('open');
    $('.enquiry-list-mask').fadeToggle(300);
    e.preventDefault();
});


// HOMEPAGE -----------------------------------------------------------------

// News Carousel
$('.news-carousel').not('.slick-initialized').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    swipeToSlide: true,
    speed: 500,
    arrows:false,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

// Case Studies Carousel
$('.homepage-case-studies-carousel').not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    swipeToSlide: true,
    speed: 500
});

// HERO ---------------------------------------------------------------------

// hero carousel
$('.has-slides').not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    fade: true,
    speed: 2000,
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000
});

// CONTENT ------------------------------------------------------------------

// Carousels

$(function() {

// Content Image Carousel
$('.content-gallery').not('.slick-initialized').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    dots: false,
    swipeToSlide: true,
    fade: true,
    cssEase: 'ease',
    speed: 500
});

// Related Content Carousel
$('.related-carousel').not('.slick-initialized').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    swipeToSlide: true,
    speed: 500,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

// SERVICES -----------------------------------------------------------------

// Related Content Carousel
$('.related-products-carousel').not('.slick-initialized').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    swipeToSlide: true,
    speed: 500,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

// TESTIMONIALS -------------------------------------------------------------

// Testimonials Carousel
$('.testimonial-carousel').not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: 'ease',
    adaptiveHeight: true,
    dots: true,
    responsive: [
        {
            breakpoint: 640,
            settings: {
                dots: false
            }
        }
    ]
});

// PRODUCTS -----------------------------------------------------------------

$('.product-gallery-carousel').not('.slick-initialized').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    asNavFor: '.product-gallery-nav',
    waitForAnimate: false,
    responsive: [
        {
            breakpoint: 640,
            settings: {
                dots: true
            }
        }
    ]
});
$('.product-gallery-nav').not('.slick-initialized').slick({
    infinite: false,
    arrows: false,
    swipe: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-gallery-carousel',
    swipeToSlide: true,
    focusOnSelect: true,
    waitForAnimate: false
});


});

// NEWS ---------------------------------------------------------------------

$('.news').masonry({
    columnWidth: '.news-grid-size',
    itemSelector: '.news-item'
});

// GALLERY ------------------------------------------------------------------

// Gallery Lightbox
$(document).ready(function () {
    $('.gallery-image').magnificPopup({
        type: 'image',
        removalDelay: 300,
        midClick: true,
        mainClass: 'mfp-animated',
        gallery: {
            enabled: true
        }
    });
});


// TEAM ---------------------------------------------------------------------

// Team Bio Modal
$(document).ready(function () {
    $('.team-bio-link').magnificPopup({
        type: 'inline',
        removalDelay: 300,
        midClick: true,
        mainClass: 'mfp-animated'
    });
});


// CONTACT ------------------------------------------------------------------

// locations map modal
// $('.location-modal-link').magnificPopup({
//     type: 'inline',
//     removalDelay: 300,
//     midClick: true,
//     mainClass: 'mfp-animated'
// });


// FILE MANAGER -------------------------------------------------------------

// file upload modal
$('.file-upload').magnificPopup({
    type: 'inline',
    removalDelay: 300,
    midClick: true,
    mainClass: 'mfp-animated',
    callbacks: {
        close: function () {
            window.location.reload();
        }
        // e.t.c.
    }
});

// create folder modal
$('.create-folder').magnificPopup({
    type: 'inline',
    removalDelay: 300,
    midClick: true,
    mainClass: 'mfp-animated'
});

// delete file modal
$('.file-delete').magnificPopup({
    type: 'inline',
    removalDelay: 300,
    midClick: true,
    mainClass: 'mfp-animated',
    callbacks: {
        beforeOpen: function () {
            $("#deleteAssetId").val($(this.st.el).data("id"));
        }
    }
});

Dropzone.options.fileUploadDropzone = {
    paramName: "file", // The name that will be used to transfer the file
    maxFilesize: 2, // MB
    createImageThumbnails: false,
    thumbnailWidth: 50,
    thumbnailHeight: 50,
};

/**
 * Footer Location Drop Down
 *
 * On change of option hide all footer locations and show selected.
 */
$('.footer-location-selection').change(function () {
    var id = $(this).val();

    $(".footer-location").addClass('hide');

    $(".footer-location[data-location-id='" + id + "']").removeClass('hide');
});

import Vue from 'vue';
import CookieConsent from './components/CookieConsent.vue';
import Counter from "@/components/Counter";
import CounterIncrement from "@/components/CounterIncrement";
import VueNumber from 'vue-number-animation';

Vue.use(VueNumber);

var app = new Vue({
    el: '#app',
    components: {
        CookieConsent,
        UserLocation
    }
});

if (document.getElementById('counter')) {
    var counter = new Vue({
        el: '#counter',
        components: {
            Counter,
            CounterIncrement
        }
    });
}